/**
 * Formats a boolean value as a localized "Selected" or "Not Selected" string
 * 
 * @param {boolean} value - The boolean value to format
 * @param {Function} t - The translation function from useTranslation()
 * @returns {string} - Translated "Selected" or "Not Selected" text
 */
export const formatBooleanValue = (value, t) => {
  return value ? t('UserDetailSelected') : t('UserDetailNotSelected')
}
